const TRIP_TYPE = {
  RT: 'Round-trip',
  OW: 'One-way',
  MD: 'Multi-destination',
}

const CABIN_CLASS = {
  ECO: 'Economy',
  PEC: 'Premium Economy',
  BUS: 'Business',
  FST: 'First',
}

const TRIP_TYPE_MENU_PROPS = {
  id: 'currency-selector',
  className: 'tripType',
  buttonProps: { variation: 'plain' },
  size: 'singleColumn',
}

const CABIN_CLASS_MENU_PROPS = {
  size: 'singleColumn',
  id: 'currency-selector',
  className: 'cabinClass',
  buttonProps: { variation: 'plain' },
}

export { TRIP_TYPE, CABIN_CLASS, TRIP_TYPE_MENU_PROPS, CABIN_CLASS_MENU_PROPS }
